<template>
  <div>
    <autoLogout />
    <loader :loader="sending || loader" />

    <v-dialog v-model="dialogAsk" max-width="450">
      <v-card>
        <v-card-title class="text-h6 text-center">
          ¿Desea registrar una cita?
        </v-card-title>
        <v-card-text>
          <p>
            Para poder crear una cita para el paciente registrado, haga clic en
            Generar Cita; si no lo desea haga clic en Regresar
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            text
            @click="
              dialogAsk = false;
              $router.push('/recepcion');
            "
            encendido--
          >
            Regresar
          </v-btn>
          <v-btn color="primary" text @click="generatedDate()">
            Generar cita
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="wrapper-content">
      <encabezado :elementos="encabezado" />
      <v-card>
        <v-card-text>
          <v-divider></v-divider>
          <v-stepper v-model="e1" flat alt-labels>
            <v-stepper-header>
              <v-stepper-step
                :complete="e1 > 1"
                step="1"
                :rules="[(value) => !!validS1]"
              >
                <span class="text-center"
                  >Información de identificación médica</span
                >
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step
                :complete="e1 > 2"
                step="2"
                :rules="[(value) => !!validS2]"
              >
                <span class="text-center">Información general</span>
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step
                :complete="e1 > 3"
                step="3"
                :rules="[(value) => !!validS3]"
              >
                <span class="text-center">Antecedentes no patológicos</span>
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step :complete="e1 > 4" step="4">
                <span class="text-center">Adjuntos</span>
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step :complete="e1 > 5" step="5">
                <span class="text-center">Información de cita</span>
              </v-stepper-step>

              <!-- <v-divider></v-divider> -->

              <!-- <v-stepper-step step="5" v-if="false">
                <span class="text-center">Información de defunción</span>
                <small>(Opcional)</small>
              </v-stepper-step> -->
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1">
                <v-container>
                  <validation-observer ref="observer1" v-slot="{ invalid }">
                    <v-form v-model="validS1" ref="formIM" lazy-validation>
                      <v-row justify="center" align="center" class="mb-5">
                        <v-col cols="4" md="4" sm="12">
                          <validation-provider
                            v-slot="{ errors }"
                            name="CURP"
                            rules="requiredCurp|curp|required"
                          >
                            <v-text-field
                              prepend-icon="mdi-account"
                              v-model.trim="objAltaPaciente.curp"
                              :counter="18"
                              :maxlength="18"
                              :error-messages="errors"
                              label="CURP*"
                              required
                              @input="upperCase($event)"
                              @blur="validateCurp"
                            >
                            </v-text-field>
                          </validation-provider>
                          <!-- <v-col cols="12">
                              <p class="caption text--secondary" >Si desconoce la CURP utiliza el formato XXXX999999XXXXXX99</p>
                            </v-col> -->
                        </v-col>
                        <v-col cols="4" md="4" sm="12">
                          <validation-provider
                            v-slot="{ errors }"
                            name="Institución aseguradora"
                            rules="required"
                          >
                            <v-autocomplete
                              prepend-icon="mdi-hospital-building"
                              v-model.trim="objAltaPaciente.idHealthInsurance"
                              label="Institución aseguradora"
                              no-data-text="Sin instituciones por mostrar"
                              :items="listHealthInsurance"
                              :item-text="listHealthInsurance.text"
                              :item-value="listHealthInsurance.value"
                              :error-messages="errors"
                              required
                              return-object
                              @change="
                                resetInputs();
                                showInput();
                              "
                            ></v-autocomplete>
                          </validation-provider>
                        </v-col>
                        <template v-if="flag">
                          <v-col cols="4" md="4" sm="12">
                            <validation-provider
                              v-slot="{ errors }"
                              name="Número de afiliación"
                              rules="regex:^[a-zA-Z0-9]+$|required"
                            >
                              <v-text-field
                                v-model.trim="objAltaPaciente.membershipNumber"
                                prepend-icon="mdi-pound-box-outline"
                                label="Número de afiliación"
                                :error-messages="errors"
                                :counter="50"
                                :maxlength="50"
                              />
                            </validation-provider>
                          </v-col>
                        </template>

                        <template v-if="hint">
                          <v-row>
                            <v-col cols="4">
                              <p class="caption text--secondary">
                                Si desconoce la CURP utiliza el formato
                                XXXX999999XXXXXX99
                              </p>
                            </v-col>
                            <v-col cols="4" offset="4">
                              <p class="caption text--secondary">
                                Si desconoce su número de afiliación o NSS
                                utiliza el formato 00000000000
                              </p>
                            </v-col>
                          </v-row>
                        </template>
                        <template v-if="hintNoaplica">
                          <v-row>
                            <v-col cols="12">
                              <p class="caption text--secondary">
                                Si desconoce la CURP utiliza el formato
                                XXXX999999XXXXXX99
                              </p>
                            </v-col>
                          </v-row>
                        </template>

                        <template
                          v-if="
                            objAltaPaciente.idHealthInsurance &&
                            objAltaPaciente.idHealthInsurance.text === 'IMSS'
                          "
                        >
                          <v-col cols="4" md="4" sm="12">
                            <validation-provider
                              v-slot="{ errors }"
                              name="NSS"
                              rules="max:11|min:11|numeric|required"
                            >
                              <v-text-field
                                prepend-icon="mdi-hospital"
                                v-model.trim="objAltaPaciente.imssNumber"
                                :error-messages="errors"
                                :maxlength="11"
                                :counter="11"
                                label="NSS"
                              />
                            </validation-provider>
                          </v-col>
                          <v-row>
                            <v-col cols="4" md="4" sm="12">
                              <p class="caption text--secondary">
                                Si desconoce la CURP utiliza el formato
                                XXXX999999XXXXXX99
                              </p>
                            </v-col>
                            <v-col cols="4" md="4" sm="12">
                              <validation-provider
                                v-slot="{ errors }"
                                name="Agregado médico"
                                rules="max:8|min:8|regex:^[a-zA-Z0-9]+$"
                              >
                                <v-text-field
                                  prepend-icon="mdi-plus-box-multiple"
                                  v-model.trim="
                                    objAltaPaciente.medicalAggregated
                                  "
                                  :error-messages="errors"
                                  :counter="8"
                                  :maxlength="8"
                                  label="Agregado médico (opcional)"
                                  @input="
                                    if (objAltaPaciente.medicalAggregated)
                                      objAltaPaciente.medicalAggregated =
                                        $event.toUpperCase();
                                  "
                                />
                              </validation-provider>
                            </v-col>
                            <v-col cols="4" md="4" sm="12">
                              <p class="caption text--secondary">
                                Si desconoce su número de afiliación o NSS
                                utiliza el formato 00000000000
                              </p>
                            </v-col>
                          </v-row>
                        </template>

                        <template
                          v-if="
                            objAltaPaciente.idHealthInsurance &&
                            objAltaPaciente.idHealthInsurance.text === 'OTRO'
                          "
                        >
                          <v-col cols="4" md="4" sm="12">
                            <p class="caption text--secondary">
                              Si desconoce la CURP utiliza el formato
                              XXXX999999XXXXXX99
                            </p>
                          </v-col>
                          <v-col cols="4" md="4" sm="12">
                            <validation-provider
                              v-slot="{ errors }"
                              name="Nombre de aseguradora"
                              rules="required"
                            >
                              <v-text-field
                                v-model.trim="objAltaPaciente.nameOther"
                                prepend-icon="mdi-shield"
                                label="Nombre de aseguradora"
                                :error-messages="errors"
                                :counter="100"
                                :maxlength="100"
                                required
                              >
                              </v-text-field>
                            </validation-provider>
                          </v-col>
                          <v-col cols="4" md="4" sm="12">
                            <p class="caption text--secondary">
                              Si desconoce su número de afiliación o NSS utiliza
                              el formato 00000000000
                            </p>
                          </v-col>
                          <v-col cols="4" md="4" sm="12">
                            <validation-provider
                              v-slot="{ errors }"
                              name="Descripción"
                              rules="required"
                            >
                              <v-text-field
                                v-model.trim="objAltaPaciente.description"
                                prepend-icon="fas fa-info"
                                label="Descripción"
                                :error-messages="errors"
                                :counter="255"
                                :maxlength="255"
                                required
                              >
                              </v-text-field>
                            </validation-provider>
                          </v-col>
                        </template>
                      </v-row>
                    </v-form>

                    <v-row
                      align="center"
                      justify="space-around"
                      class="d-flex flex-row-reverse mt-5"
                    >
                      <v-col class="text-center">
                        <v-btn
                          color="primary"
                          @click="
                            e1 = 2;
                            validStep(e1 - 1);
                            initCurpValidation();
                          "
                          :disabled="invalid"
                        >
                          Siguiente <v-icon right>mdi-chevron-right</v-icon>
                        </v-btn>
                      </v-col>
                      <v-col class="text-center">
                        <v-btn plain @click="cleanModal(e1 - 1)" color="error">
                          Cancelar <v-icon right>mdi-close</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </validation-observer>
                </v-container>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-container>
                  <validation-observer ref="stepb" v-slot="{ invalid }">
                    <v-form v-model="validS2" ref="formIP" lazy-validation>
                      <v-row>
                        <v-col>
                          <h3 class="font-weight-black mb-5">
                            Información personal
                          </h3>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="3" sm="12">
                          <!-- rules="required|max:50|min:2|nameWithDot" -->

                          <validation-provider
                            v-slot="{ errors }"
                            name="Nombre"
                            rules="required|max:50|min:2"
                          >
                            <v-text-field
                              prepend-icon="mdi-account"
                              v-model.trim="objAltaPaciente.name"
                              :error-messages="errors"
                              label="Nombre(s)*"
                              :counter="50"
                              :maxlength="50"
                              required
                              @change="firstLetterToUpperCase()"
                            ></v-text-field>
                          </validation-provider>
                        </v-col>

                        <v-col cols="12" md="3" sm="12">
                          <validation-provider
                            v-slot="{ errors }"
                            name="Primer apellido"
                            rules="required|max:60|min:2|regex:^[a-zA-ZÀ-ÿ ]+$"
                          >
                            <v-text-field
                              prepend-icon="mdi-card-account-details"
                              v-model.trim="objAltaPaciente.firstLastname"
                              :error-messages="errors"
                              label="Primer apellido*"
                              :counter="60"
                              :maxlength="60"
                              required
                              @change="firstLetterToUpperCase()"
                            ></v-text-field>
                          </validation-provider>
                        </v-col>

                        <v-col cols="12" md="3" sm="12">
                          <validation-provider
                            v-slot="{ errors }"
                            name="Segundo apellido"
                            rules="max:60|min:2|regex:^[a-zA-ZÀ-ÿ ]+$"
                          >
                            <v-text-field
                              prepend-icon="mdi-card-account-details-outline"
                              v-model.trim="objAltaPaciente.secondLastname"
                              :error-messages="errors"
                              label="Segundo apellido"
                              :counter="60"
                              :maxlength="60"
                              @change="firstLetterToUpperCase()"
                            ></v-text-field>
                          </validation-provider>
                        </v-col>
                        <v-col cols="12" md="3" sm="12">
                          <validation-provider
                            v-slot="{ errors }"
                            name="Sexo"
                            rules="required"
                          >
                            <v-select
                              prepend-icon="mdi-gender-male-female"
                              v-model="objAltaPaciente.gender"
                              :item-text="genero.text"
                              :item-value="genero.value"
                              :items="genero"
                              :error-messages="errors"
                              label="Sexo*"
                              required
                            ></v-select>
                          </validation-provider>
                        </v-col>
                      </v-row>
                      <v-row class="mb-3">
                        <v-col cols="12" md="3" sm="12">
                          <validation-provider
                            v-slot="{ errors }"
                            name="Nacionalidad"
                            rules="required"
                          >
                            <v-autocomplete
                              prepend-icon="mdi-flag-variant-outline"
                              v-model="objAltaPaciente.nationality"
                              label="Nacionalidad*"
                              :items="nationality"
                              :item-text="nationality.text"
                              :item-value="nationality.value"
                              required
                              :error-messages="errors"
                              no-data-text="Sin resultados disponibles"
                            ></v-autocomplete>
                          </validation-provider>
                        </v-col>
                        <template
                          v-if="
                            objAltaPaciente.nationality &&
                            objAltaPaciente.nationality === 'Otro'
                          "
                        >
                          <v-col cols="3" md="3" sm="12">
                            <validation-provider
                              v-slot="{ errors }"
                              name="Nombre de Nacionalidad"
                              rules="required|alpha"
                            >
                              <v-text-field
                                prepend-icon="mdi-flag-variant-outline"
                                v-model.trim="otherNationality"
                                label="Nombre de Nacionalidad*"
                                :error-messages="errors"
                                :counter="50"
                                :maxlength="50"
                                required
                              >
                              </v-text-field>
                            </validation-provider>
                          </v-col>
                        </template>

                        <v-col>
                          <validation-provider
                              v-slot="{ errors }"
                              name="Fecha de nacimiento"
                              rules="required"
                            >
                          <v-text-field
                            type="date"
                            v-model="date"
                            :max="new Date().toISOString().split('T')[0]"
                            label="Fecha de nacimiento*"
                            :rules="nameRules"
                            hint="Formato DD/MM/YYYY"
                            required
                            :error-messages="errors"
                          ></v-text-field>
                        </validation-provider>

                        </v-col>
                        <v-col
                          v-if="objAltaPaciente.nationality != 'Otro'"
                          cols="12"
                          md="3"
                          sm="12"
                        >
                          <validation-provider
                            v-slot="{ errors }"
                            name="Entidad federativa"
                            rules="required"
                          >
                            <v-autocomplete
                              prepend-icon="fas fa-map-pin"
                              v-model="objAltaPaciente.birthFederalEntity"
                              label="Entidad federativa de nacimiento*"
                              :error-messages="errors"
                              :items="birthFederalEntities"
                              :item-text="birthFederalEntities.text"
                              :item-value="birthFederalEntities.value"
                              required
                            ></v-autocomplete>
                          </validation-provider>
                        </v-col>

                        <v-col cols="12" md="3" sm="12">
                          <validation-provider
                            v-slot="{ errors }"
                            name="Estado civil"
                            rules="required"
                          >
                            <v-autocomplete
                              prepend-icon="mdi-account-heart"
                              v-model="objAltaPaciente.maritalStatus"
                              :items="estadoCivil"
                              :item-text="estadoCivil.text"
                              :item-value="estadoCivil.value"
                              label="Estado civil*"
                              :error-messages="errors"
                              required
                            ></v-autocomplete>
                          </validation-provider>
                        </v-col>
                        <v-col cols="12" md="3" sm="12">
                          <validation-provider
                            v-slot="{ errors }"
                            name="RFC"
                            rules="max:13|min:12"
                          >
                            <v-text-field
                              prepend-icon="mdi-account-file-text-outline"
                              v-model.trim="objAltaPaciente.rfc"
                              :error-messages="errors"
                              label="RFC"
                              :counter="13"
                              :maxlength="13"
                              @input="if(objAltaPaciente.rfc)objAltaPaciente.rfc = $event.toUpperCase()"
                            ></v-text-field>
                          </validation-provider>
                        </v-col>
                        <v-col cols="12" md="3" sm="12">
                          <validation-provider
                            v-slot="{ errors }"
                            name="Lengua indígena"
                            rules="required"
                          >
                            <v-select
                                    prepend-icon="mdi-tilde"
          v-model="objAltaPaciente.indigenousLanguage"
          :items="languages"
          :item-text="languages.text"
          :item-value="languages.value"
          label="¿Habla una lengua indígena?*"
          required
                            ></v-select>
                          </validation-provider>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="5" md="5" sm="12" v-if="showVotingLicense">
                          <h3 class="font-weight-black mb-5">
                            Información electoral
                          </h3>
                          <v-row>
                          <v-col cols="7" md="7" sm="12" v-if="showVotingLicense">
                          <v-text-field
                            prepend-icon="mdi-credit-card"
                            v-model.trim="objAltaPaciente.votingLicenseKey"
                            label="Clave de elector"
                            :counter="18"
                            :maxlength="18"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col cols="5" md="5" sm="12" v-if="showVotingLicense">
                          <v-text-field
                            prepend-icon="mdi-map"
                            v-model.trim="objAltaPaciente.section"
                            label="Sección"
                            :counter="5"
                            :maxlength="5"
                          >
                          </v-text-field>
                        </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="4" md="4" sm="12">
                          <h3 class="font-weight-black mb-5">
                            Información laboral
                          </h3>
                          <v-row>
                          <v-col cols="12">
                          <v-autocomplete
                            prepend-icon="mdi-account-cog"
                            v-model="objAltaPaciente.idOccupation"
                            label="Ocupación"
                            :items="joblist"
                            item-text="name"
                            return-object
                            no-data-text="sin ocupaciones para mostrar"
                          >
                          </v-autocomplete>
                        </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="3" md="3" sm="12">
                          <h3 class="font-weight-black mb-5">
                            Información escolar
                          </h3>
                        <v-row>
                        <v-col cols="12">
                          <v-autocomplete
                            prepend-icon="mdi-account-school"
                            v-model="objAltaPaciente.educationName"
                            label="Escolaridad"
                            :items="$cnst.SCHOOL_GRADES"
                            item-text="name"
                            return-object
                          >
                          </v-autocomplete>
                        </v-col>
                      </v-row>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <h3 class="font-weight-black mb-5">
                            Información de contacto
                          </h3>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" md="8" sm="12">
                          <validation-provider
                            v-slot="{ errors }"
                            name="Dirección"
                            rules="required|max:100|regex:^[a-zA-Z0-9 ]"
                          >
                            <v-text-field
                              prepend-icon="fas fa-road"
                              v-model.trim="objAltaPaciente.street"
                              :counter="100"
                              :maxlength="100"
                              label="Dirección*"
                              :error-messages="errors"
                              required
                            ></v-text-field>
                          </validation-provider>
                        </v-col>

                        <v-col cols="12" md="2" sm="12">
                          <validation-provider
                            v-slot="{ errors }"
                            name="Número exterior"
                            rules="required"
                          >
                            <v-text-field
                              prepend-icon="mdi-pound"
                              v-model.trim="objAltaPaciente.outdoorNumber"
                              :counter="5"
                              :maxLength="5"
                              label="Número exterior*"
                              :error-messages="errors"
                              required
                            ></v-text-field>
                          </validation-provider>
                        </v-col>

                        <v-col cols="12" md="2" sm="12">
                          <validation-provider
                            v-slot="{ errors }"
                            name="Número interior"
                            rules="required"
                          >
                            <v-text-field
                              prepend-icon="mdi-pound-box-outline"
                              v-model.trim="objAltaPaciente.interiorNumber"
                              :error-messages="errors"
                              :counter="5"
                              :maxlength="5"
                              label="Número interior"
                            >
                            </v-text-field>
                          </validation-provider>
                          <p class="caption text--secondary">
                            Si el domicilio no cuenta con número interior
                            utiliza el formato N/D
                          </p>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" md="3" sm="12">
                          <validation-provider
                            v-slot="{ errors }"
                            name="Código postal"
                            rules="required|max:5|min:1|numeric|regex:^[0-9]+$"
                          >
                            <v-text-field
                              prepend-icon="mdi-mailbox-outline"
                              v-model="objAltaPaciente.postalCode"
                              :counter="5"
                              maxlength="5"
                              label="Código postal*"
                              :error-messages="errors"
                              required
                              @change="findAddress"
                            ></v-text-field>
                          </validation-provider>
                        </v-col>

                        <v-col cols="12" md="3" sm="12" v-if="!noPostal">
                          <validation-provider
                            v-slot="{ errors }"
                            name="Entidad federativa"
                            rules="required"
                          >
                            <v-autocomplete
                              prepend-icon="mdi-map-marker-radius"
                              v-model="objAltaPaciente.federalEntityKey"
                              label="Entidad federativa de residencia*"
                              :error-messages="errors"
                              :items="federalEntities"
                              :item-text="federalEntities.text"
                              :item-value="federalEntities.value"
                              :disabled="!validAdress"
                              required
                              auto-select-first
                            >
                            </v-autocomplete>
                          </validation-provider>
                        </v-col>

                        <v-col cols="12" md="3" sm="12" v-if="!noPostal">
                          <validation-provider
                            v-slot="{ errors }"
                            name="Municipio"
                            rules="required"
                          >
                            <v-autocomplete
                              prepend-icon="mdi-map-outline"
                              v-model="objAltaPaciente.municipalityKey"
                              label="Municipio*"
                              :error-messages="errors"
                              :items="municipalities"
                              :item-text="municipalities.text"
                              :item-value="municipalities.value"
                              required
                              :disabled="!validAdress"
                              auto-select-first
                            ></v-autocomplete>
                          </validation-provider>
                        </v-col>

                        <v-col cols="12" md="3" sm="12" v-if="!noPostal">
                          <validation-Provider
                            v-slot="{ errors }"
                            name="Colonia"
                            rules="required"
                          >
                            <v-autocomplete
                              prepend-icon="mdi-map-marker"
                              v-model="objAltaPaciente.colonyKey"
                              :items="colonies"
                              :item-text="colonies.text"
                              :item-value="colonies.value"
                              :loading="isLoading"
                              label="Colonia*"
                              :error-messages="errors"
                              :disabled="!validAdress"
                              required
                              auto-select-first
                              @change="checkColony"
                            ></v-autocomplete>
                          </validation-Provider>
                        </v-col>
                        <v-col cols="12" md="3" sm="12" v-if="noPostal">
                          <validation-provider
                            v-slot="{ errors }"
                            name="Entidad federativa"
                            rules="required|max:100"
                          >
                            <v-text-field
                              prepend-icon="mdi-map-marker-radius"
                              v-model="objAltaPaciente.federalEntityKey"
                              label="Entidad federativa de residencia*"
                              :error-messages="errors"
                              required
                              :counter="100"
                              :maxlength="100"
                            ></v-text-field>
                          </validation-provider>
                        </v-col>

                        <v-col cols="12" md="3" sm="12" v-if="noPostal">
                          <validation-provider
                            v-slot="{ errors }"
                            name="Municipio"
                            rules="required|max:100"
                          >
                            <v-text-field
                              prepend-icon="mdi-map-outline"
                              v-model="objAltaPaciente.municipalityKey"
                              :counter="100"
                              :maxlength="100"
                              label="Municipio*"
                              :error-messages="errors"
                              required
                            >
                            </v-text-field>
                          </validation-provider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="3"
                          sm="12"
                          v-if="noPostal || noColony"
                        >
                          <validation-Provider
                            v-slot="{ errors }"
                            name="Colonia"
                            rules="required|max:100"
                          >
                            <v-text-field
                              prepend-icon="mdi-map-marker"
                              v-model.trim="otherColony"
                              :loading="isLoading"
                              label="Colonia*"
                              :error-messages="errors"
                              required
                              :counter="100"
                              :maxlength="100"
                            >
                            </v-text-field>
                          </validation-Provider>
                        </v-col>
                      </v-row>

                      <v-row class="mb-3">
                        <v-col cols="12" md="4" sm="12">
                          <validation-provider
                            v-slot="{ errors }"
                            name="Correo electrónico"
                            rules="email|required"
                          >
                            <v-text-field
                              prepend-icon="mdi-at"
                              v-model.trim="objAltaPaciente.email"
                              :counter="50"
                              :maxlength="50"
                              label="Correo electrónico"
                              type="email"
                              :error-messages="errors"
                              @input="
                                if (objAltaPaciente.email)
                                  objAltaPaciente.email = $event.toLowerCase();
                              "
                            ></v-text-field>
                          </validation-provider>
                          <p class="caption text--secondary">
                            Si desconoce el correo electrónico utiliza el
                            formato N/D
                          </p>
                        </v-col>

                        <v-col cols="12" md="4" sm="12">
                          <validation-provider
                            v-slot="{ errors }"
                            name="Teléfono movil"
                            rules="max:10|min:10|required|phonenumber"
                          >
                            <v-text-field
                              prepend-icon="mdi-cellphone"
                              v-model="objAltaPaciente.phone"
                              :counter="10"
                              :maxLength="10"
                              label="Número telefónico móvil"
                              :error-messages="errors"
                              required
                            >
                            </v-text-field>
                          </validation-provider>
                          <!-- <p class="caption text--secondary">
                            Si desconoce el número telefónico utiliza el
                            formato 0000000000
                          </p> -->
                        </v-col>

                        <v-col cols="12" md="4" sm="12">
                          <validation-provider
                            v-slot="{ errors }"
                            name="Teléfono fijo"
                            rules="max:10|min:10|phonenumber"
                          >
                            <v-text-field
                              prepend-icon="mdi-phone"
                              v-model="objAltaPaciente.homePhone"
                              :error-messages="errors"
                              :counter="10"
                              :maxLength="10"
                              label="Número telefónico fijo(Opcional)"
                            >
                            </v-text-field>
                          </validation-provider>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="flex pt-0" cols="12">
                            <validation-provider
                              v-slot="{ errors }"
                              name="Enviar informacion"
                              rules="required"
                            >
                              <v-radio-group 
                                row 
                                v-model="objAltaPaciente.sendInformation"
                                :error-messages="errors"
                              >
                                <template v-slot:label>
                                  <div><h4  style="font-size:auto">¿Deseas que te enviemos información?</h4></div>
                                </template>
                                <v-radio :value="true">
                                  <template v-slot:label>
                                    <div><strong>Sí</strong></div>
                                  </template>
                                </v-radio>
                                <v-radio :value="false">
                                  <template v-slot:label>
                                    <div><strong>No</strong></div>
                                  </template>
                                </v-radio>
                              </v-radio-group>
                            </validation-provider>
                        </v-col>
                      </v-row>
                      <v-subheader>Fotografía (opcional) </v-subheader>
                      <v-row justify="center" align="center">
                        <v-col cols="12" md="6" sm="12" xl="4">
                          <CameraSuim
                            :videoTypes="['camera']"
                            ref="cameraSUIM"
                          />
                        </v-col>
                      </v-row>
                    </v-form>

                    <v-row
                      align="center"
                      justify="space-around"
                      class="d-flex flex-row-reverse mt-5"
                    >
                      <v-col class="text-center">
                        <v-btn
                          color="primary"
                          @click="
                            e1 = 3;
                            validStep(e1 - 1);
                          "
                          :disabled="invalid"
                        >
                          Siguiente <v-icon right>mdi-chevron-right</v-icon>
                        </v-btn>
                      </v-col>

                      <v-col class="text-center">
                        <v-btn plain @click="cleanModal(e1 - 1)" color="error">
                          Cancelar <v-icon right>mdi-close</v-icon>
                        </v-btn>
                      </v-col>

                      <v-col class="text-center">
                        <v-btn color="secondary" text @click="e1 = 1">
                          <v-icon left>mdi-chevron-left</v-icon> Regresar
                        </v-btn>
                      </v-col>
                    </v-row>
                  </validation-observer>
                </v-container>
              </v-stepper-content>

              <v-stepper-content step="3">
                <v-container>
                  <validation-observer v-slot="{ invalid }">
                    <v-form v-model="validS3" ref="formIC" lazy-validation>
                      <v-expansion-panels v-model="panel" multiple>
                        <v-expansion-panel
                          v-for="(item, index) in antecedents"
                          :key="index"
                        >
                          <v-expansion-panel-header>
                            {{ item.name }}
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-row align="baseline">
                              <v-col
                                v-for="(question, subindex) in item.questions"
                                :key="subindex"
                              >
                                <span>{{ question.name }}</span>
                                <validation-provider
                                  v-slot="{ errors }"
                                  :name="question.name"
                                  :rules="
                                    question.required == 1 ? 'required' : ''
                                  "
                                >
                                  <v-radio-group
                                    v-if="
                                      question.typeAnswer == 2 ||
                                      question.typeAnswer == 4
                                    "
                                    v-model="question.idAnswer"
                                    :error-messages="errors"
                                    :required="question.required == 1"
                                  >
                                    <v-radio
                                      v-for="(
                                        answer, sub_subindex
                                      ) in question.answers"
                                      :key="sub_subindex"
                                      :value="answer.idAnswer"
                                      :label="answer.name"
                                    />
                                  </v-radio-group>

                                  <v-autocomplete
                                    v-if="question.typeAnswer == 3"
                                    v-model="question.selectedAnswers"
                                    :items="question.answers"
                                    item-text="name"
                                    item-value="idAnswer"
                                    :error-messages="errors"
                                    auto-select-first
                                    chips
                                    clearable
                                    deletable-chips
                                    multiple
                                    small-chips
                                    dense
                                    :required="question.required == 1"
                                  />

                                  <v-text-field
                                    v-if="
                                      (question.typeAnswer == 1 ||
                                        question.typeAnswer == 4) &&
                                      question.typeData != 6
                                    "
                                    v-model="question.answer"
                                    :error-messages="errors"
                                    :type="question.typeDataText"
                                    :required="question.required == 1"
                                    autocomplete="off"
                                    dense
                                    clearable
                                  />

                                  <v-textarea
                                    v-if="
                                      (question.typeAnswer == 1 ||
                                        question.typeAnswer == 4) &&
                                      question.typeData == 6
                                    "
                                    v-model="question.answer"
                                    :error-messages="errors"
                                    outlined
                                    dense
                                    clearable
                                  />
                                </validation-provider>
                              </v-col>
                            </v-row>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-form>

                    <v-row
                      align="center"
                      justify="space-around"
                      class="d-flex flex-row-reverse mt-5"
                    >
                      <v-col class="text-center">
                        <v-btn
                          color="primary"
                          @click="
                            e1 = 4;
                            validStep(e1 - 1);
                          "
                          :disabled="invalid"
                        >
                          Siguiente <v-icon>mdi-chevron-right</v-icon>
                        </v-btn>
                      </v-col>
                      <v-col class="text-center">
                        <v-btn plain @click="cleanModal(e1 - 1)" color="error">
                          Cancelar <v-icon right>mdi-close</v-icon>
                        </v-btn>
                      </v-col>
                      <v-col class="text-center">
                        <v-btn color="secondary" text @click="e1 = 2">
                          <v-icon left>mdi-chevron-left</v-icon> Regresar
                        </v-btn>
                      </v-col>
                    </v-row>
                  </validation-observer>
                </v-container>
              </v-stepper-content>

              <v-stepper-content step="4">
                <v-container>
                  <v-form ref="formAD">
                    <v-row>
                      <v-col>
                        <h3 class="font-weight-black mb-5">
                          Archivos adjuntos
                        </h3>
                      </v-col>
                    </v-row>
                    <v-row align="center" justify="center">
                      <v-col cols="12" md="6" sm="12" xl="4">
                        <v-file-input
                          v-model="files"
                          placeholder="Seleccione los archivos"
                          label="Adjuntar archivos"
                          multiple
                          show-size
                          counter
                          accept="image/png, image/jpeg, image/jpg, image/bmp, application/pdf"
                          prepend-icon="mdi-paperclip"
                        ></v-file-input>
                      </v-col>
                    </v-row>
                    <v-row
                      class="d-flex flex-nowrap mb-3"
                      justify="center"
                      align="baseline"
                    >
                      <v-col
                        cols="2"
                        class="text-center"
                        v-for="(file, index) in files"
                        :key="index"
                      >
                        <div class="d-flex flex-column justify-center">
                          <div class="d-flex justify-end">
                            <v-btn icon @click="deleteFile(file.name)">
                              <v-icon size="24px" color="error"
                                >mdi-close</v-icon
                              >
                            </v-btn>
                          </div>
                          <v-icon
                            style="font-size: 5rem; text-align: center"
                            size="60px"
                            :color="
                              file.type === 'application/pdf'
                                ? 'error'
                                : 'grey' || file.type === 'image/jpeg'
                                ? 'secondary'
                                : 'grey'
                            "
                            >{{
                              file.type === "application/pdf"
                                ? "mdi-file-pdf-box"
                                : "mdi-file" || file.type === "image/jpeg"
                                ? "mdi-image"
                                : "mdi-file"
                            }}</v-icon
                          >
                          <h1 class="mt-2 txt-addendums">
                            {{ file.name }}
                          </h1>
                        </div>
                      </v-col>
                    </v-row>

                    <!-- <v-row class="d-flex flex-row"> -->
                    <v-row>
                      <v-col>
                        <h3 class="font-weight-black">Formato de Escaneo:</h3>
                        <h5 class="font-weight-medium">
                          (Seleccione el formato de escaneo deseado)
                        </h5>
                      </v-col>
                    </v-row>
                    <!-- </v-row> -->

                    <v-row
                      align="center"
                      justify="center"
                      class="text-center my-5"
                    >
                      <v-col>
                        <v-btn
                          outlined
                          @click="
                            cambio = 0;
                            ScannerIMG();
                          "
                          :color="cambio != 0 ? '#DEDEDE' : 'secondary'"
                        >
                          <v-icon left>mdi-image</v-icon> Escanear como Imagen
                        </v-btn>
                      </v-col>

                      <v-col>
                        <v-btn
                          outlined
                          @click="
                            cambio = 1;
                            ScannerPDF();
                          "
                          :color="cambio != 1 ? '#DEDEDE' : 'error'"
                        >
                          <v-icon left>mdi-file-pdf-box</v-icon>Escanear como
                          PDF
                        </v-btn>
                      </v-col>
                    </v-row>

                    <v-row class="d-flex flex-nowrap" align="baseline">
                      <v-col
                        cols="3"
                        class="text-center"
                        align="center"
                        v-for="(scannedImage, index) in scannedImages"
                        :key="index"
                      >
                        <img :src="scannedImage.file64" height="220" />
                        <v-btn
                          class="mx-2"
                          @click="scannedImages.splice(index, 1)"
                          fab
                          mdi-icon
                          x-small
                          light
                        >
                          <v-icon x-large color="red">mdi-delete-circle</v-icon>
                        </v-btn>
                        <validation-provider
                          v-slot="{ errors }"
                          :name="index + 1 + '. Imagen'"
                          rules="required"
                        >
                          <v-text-field
                            prepend-icon="mdi-file"
                            v-model.trim="scannedImage.fileName"
                            :error-messages="errors"
                            label="Nombre de archivo"
                            required
                          >
                          </v-text-field>
                        </validation-provider>
                      </v-col>
                    </v-row>

                    <v-row class="d-flex flex-nowrap" align="baseline">
                      <v-col
                        align="center"
                        cols="3"
                        class="text-center"
                        v-for="(pdf, index) in scannedPDF"
                        :key="index"
                      >
                        <iframe :src="pdf.file64" height="220" />
                        <br />
                        <v-btn
                          class="mx-2"
                          @click="scannedPDF.splice(index, 1)"
                          fab
                          mdi-icon
                          x-small
                          light
                        >
                          <v-icon x-large color="red">mdi-delete-circle</v-icon>
                        </v-btn>

                        <validation-provider
                          v-slot="{ errors }"
                          :name="index + 1 + '. Documento'"
                          rules="required"
                        >
                          <v-text-field
                            prepend-icon="mdi-file"
                            v-model.trim="pdf.fileName"
                            :error-messages="errors"
                            label="Nombre de archivo"
                            required
                          >
                          </v-text-field>
                        </validation-provider>
                      </v-col>
                    </v-row>

                    <div id="divScaner">
                      <div class="row">
                        <div id="separator" v-show="switchDiv">
                          <v-row>
                            <v-col style="margin-left: 250px">
                              <v-card
                                elevation="24"
                                max-width="444"
                                class="mx-auto"
                                color="transparent"
                              >
                                <v-dialog
                                  v-model="dialog"
                                  max-width="1000"
                                  eager
                                  scrollable
                                  v-for="(src, index) in imagenesVisuali"
                                  :key="index"
                                >
                                  <v-card>
                                    <v-card-title class="text-h5">
                                      Visualizador de archivos IMG
                                    </v-card-title>

                                    <v-img
                                      :src="src"
                                      @click="index = imagenesVisuali"
                                    ></v-img>
                                    <v-sheet :src="src" height="100%" tile>
                                    </v-sheet>
                                  </v-card>
                                </v-dialog>

                                <v-carousel v-model="model">
                                  <v-carousel-item
                                    cols="2"
                                    v-for="(src, index) in imageAr"
                                    :key="index"
                                  >
                                    <v-btn
                                      color="secondary"
                                      fab
                                      x-small
                                      dark
                                      @click.stop="
                                        dialog = true;
                                        viawerIMG(src);
                                      "
                                    >
                                      <v-icon>mdi-eye</v-icon>
                                    </v-btn>
                                    <v-btn
                                      color="red"
                                      fab
                                      x-small
                                      dark
                                      @click="deleteIMG(src)"
                                    >
                                      <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                    <v-icon
                                      right
                                      color="blue"
                                      height="50%"
                                      style="margin-left: 320px"
                                      >mdi-image
                                    </v-icon>

                                    <v-img
                                      :src="src"
                                      @click="index = imageAr"
                                    ></v-img>
                                    <v-sheet :src="src" height="100%" tile>
                                    </v-sheet>
                                  </v-carousel-item>
                                </v-carousel>
                              </v-card>
                            </v-col>
                            <v-col>
                              <v-card
                                elevation="24"
                                max-width="444"
                                class="mx-auto"
                                color="transparent"
                              >
                                <v-carousel v-model="xk">
                                  <v-carousel-item
                                    cols="2"
                                    v-for="(src, index) in pdfAr"
                                    :key="index"
                                  >
                                    <v-dialog
                                      v-model="dialogViewer"
                                      max-width="800px"
                                      transition="dialog-top-transition"
                                    >
                                      <v-card>
                                        <v-card-title
                                          class="text-h6 text-center"
                                        >
                                          Archivo anexo
                                        </v-card-title>

                                        <div
                                          class="container"
                                          v-if="pdbBase != 'application/pdf'"
                                        >
                                          <div
                                            style="justify-content: center"
                                            class="row overflow-y-auto"
                                          >
                                            <div
                                              style="justify-content: center"
                                              class="row overflow-y-auto"
                                            >
                                              <iframe
                                                :src="pdbBase"
                                                width="100%"
                                                height="600"
                                              >
                                              </iframe>
                                            </div>
                                          </div>
                                        </div>
                                      </v-card>
                                    </v-dialog>

                                    <v-btn
                                      color="secondary"
                                      fab
                                      x-small
                                      dark
                                      @click="viawerPDF(src)"
                                    >
                                      <v-icon>mdi-eye</v-icon>
                                    </v-btn>

                                    <v-btn
                                      color="green"
                                      fab
                                      x-small
                                      dark
                                      @click="ViewAllPDF()"
                                    >
                                      <v-icon>mdi-collapse-all</v-icon>
                                    </v-btn>

                                    <v-btn
                                      color="red"
                                      fab
                                      x-small
                                      dark
                                      @click="deletePDF(src)"
                                    >
                                      <v-icon>mdi-delete</v-icon>
                                    </v-btn>

                                    <v-icon
                                      color="red"
                                      right
                                      height="50%"
                                      style="margin-left: 320px"
                                      >mdi-file-pdf-box
                                    </v-icon>
                                    <v-img :src="src"> </v-img>
                                    <v-sheet :src="src" height="100%" tile>
                                    </v-sheet>
                                  </v-carousel-item>
                                </v-carousel>
                              </v-card>
                            </v-col>
                          </v-row>
                        </div>
                      </div>
                    </div>
                  </v-form>
                  <br />
                  <br />
                  <br />
                  <v-row align="center" justify="space-around" class="mt-5">
                    <v-btn
                      color="secondary"
                      text
                      @click="
                        e1 = 3;
                        encendido--;
                      "
                    >
                      <v-icon left>mdi-chevron-left</v-icon> Regresar
                    </v-btn>

                    <v-btn text @click="cleanModal(e1 - 1)" color="error">
                      Cancelar <v-icon right>mdi-close</v-icon>
                    </v-btn>

                    <v-btn
                      color="primary"
                      @click="
                        e1 = 5;
                        validStep(e1 - 1);
                        encendido++;
                      "
                    >
                      Siguiente <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                  </v-row>
                </v-container>
              </v-stepper-content>

              <v-stepper-content step="5" v-if="false">
                <v-container>
                  <v-form ref="formID">
                    <v-row>
                      <v-col cols="12" md="6" sm="12">
                        <v-menu
                          ref="menu3"
                          v-model="menu3"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              id="fechaNac1"
                              v-model="dateFormatted1"
                              label="Fecha de fallecimiento"
                              hint="Formato DD/MM/YYYY"
                              prepend-icon="mdi-calendar"
                              v-bind="attrs"
                              @blur="date3 = parseDate(dateFormatted1)"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            :max-date="new Date()"
                            v-model="date3"
                            @input="menu3 = false"
                            locale="es"
                            :active-picker.sync="activePicker1"
                            min="1950-01-01"
                            @change="saveDef"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" md="6" sm="12">
                        <v-textarea
                          prepend-icon="mdi-emoticon-dead"
                          v-model="objAltaPaciente.indicardoFallecimiento"
                          auto-grow
                          rows="1"
                          label="Indicador de fallecimiento"
                          hint=""
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-form>
                  <v-row
                    align="center"
                    justify="space-around"
                    class="d-flex flex-row-reverse mt-20"
                  >
                    <v-col class="text-center">
                      <v-btn
                        color="primary"
                        @click="
                          e1 = 5;
                          saveFilesToPatient();
                        "
                        :disabled="sending"
                        >Guardar</v-btn
                      >
                    </v-col>
                    <v-col class="text-center">
                      <v-btn
                        plain
                        @click="
                          cleanModal(e1 - 1);
                          cambio = 0;
                        "
                        color="error"
                      >
                        Cancelar <v-icon right>mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                    <v-col class="text-center">
                      <v-btn color="secondary" text @click="e1 = 4">
                        <v-icon left>mdi-chevron-left</v-icon> Regresar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-stepper-content>
              <v-stepper-content step="5">
                <v-container>
                  <v-row justify="center" class="mt-2">
                    <v-col cols="3" sm="12" md="2" lg="3">
                      <v-switch
                        v-model="referringPhysicianSwitch"
                        label="Médico referido"
                        color="success"
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <validation-observer ref="observer1" v-slot="{ invalid }">
                    <v-form v-model="validS1" lazy-validation>
                      <div v-if="referringPhysicianSwitch">
                        <v-row>
                          <v-col>
                            <h3 class="font-weight-black mb-5">
                              Médico referido
                            </h3>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <validation-provider
                              v-slot="{ touched, invalid, errors }"
                              name="Título académico"
                              rules="required|max:20|min:1|regex:^[a-zA-ZÀ-ÿ ]+\.?$"
                            >
                              <v-text-field
                                :error-messages="errors"
                                label="Título académico"
                                required
                                clearable
                                :clear-icon="$cnst.CLEAR_ICON"
                                prepend-icon="mdi-folder-account"
                                :counter="20"
                                :maxlength="20"
                                v-model="referringPhysician.academicTitle"
                              >
                                <v-icon
                                  slot="append"
                                  :color="touched && invalid ? 'error' : ''"
                                >
                                  {{ touched && invalid ? "mdi-alert" : "" }}
                                </v-icon>
                              </v-text-field>
                            </validation-provider>
                          </v-col>
                          <v-col>
                            <!-- rules="required|max:60|min:2|nameWithDot" -->

                            <validation-provider
                              v-slot="{ touched, invalid, errors }"
                              name="Nombre"
                              rules="required|max:60|min:2"
                            >
                              <v-text-field
                                :error-messages="errors"
                                label="Nombre(s)*"
                                required
                                clearable
                                :clear-icon="$cnst.CLEAR_ICON"
                                prepend-icon="mdi-account"
                                :counter="60"
                                :maxlength="60"
                                v-model="referringPhysician.name"
                              >
                                <v-icon
                                  slot="append"
                                  :color="touched && invalid ? 'error' : ''"
                                >
                                  {{ touched && invalid ? "mdi-alert" : "" }}
                                </v-icon>
                              </v-text-field>
                            </validation-provider>
                          </v-col>
                          <v-col>
                            <validation-provider
                              v-slot="{ touched, invalid, errors }"
                              name="Primer apellido"
                              rules="required|max:60|min:2|regex:^[a-zA-ZÀ-ÿ ]+$"
                            >
                              <v-text-field
                                :error-messages="errors"
                                label="Primer apellido"
                                required
                                clearable
                                :clear-icon="$cnst.CLEAR_ICON"
                                prepend-icon="mdi-card-account-details"
                                :counter="60"
                                :maxlength="60"
                                v-model="referringPhysician.firstLastname"
                              >
                                <v-icon
                                  slot="append"
                                  :color="touched && invalid ? 'error' : ''"
                                >
                                  {{ touched && invalid ? "mdi-alert" : "" }}
                                </v-icon>
                              </v-text-field>
                            </validation-provider>
                          </v-col>
                          <v-col>
                            <validation-provider
                              v-slot="{ invalid, errors, touched }"
                              name="Segundo apellido"
                              rules="max:60|min:2|regex:^[a-zA-ZÀ-ÿ ]+$"
                            >
                              <v-text-field
                                :error-messages="errors"
                                label="Segundo apellido"
                                clearable
                                :clear-icon="$cnst.CLEAR_ICON"
                                prepend-icon="mdi-card-account-details-outline"
                                :counter="60"
                                :maxlength="60"
                                v-model="referringPhysician.secondLastname"
                              >
                                <v-icon
                                  slot="append"
                                  :color="touched && invalid ? 'error' : ''"
                                >
                                  {{ touched && invalid ? "mdi-alert" : "" }}
                                </v-icon>
                              </v-text-field>
                            </validation-provider>
                          </v-col>
                        </v-row>
                      </div>
                      <v-row>
                        <v-col>
                          <h3 class="font-weight-black mb-5">Cita Médica</h3>
                        </v-col>
                      </v-row>
                      <v-row justify="center" align="center" class="mb-5">
                        <v-col cols="6" class="text-left">
                          <v-text-field
                            :value="
                              $utilFront.formatDateTime(
                                objAltaPaciente.appointmentDate
                              )
                            "
                            label="Fecha de cita"
                            disabled
                            autocomplete="off"
                            dense
                            type="text"
                          />
                          <!-- <validation-provider
                            v-slot="{ valid }"
                            name="Fecha cita"
                            rules="required"
                          >
                            <vc-date-picker
                              color="green"
                              v-model="objAltaPaciente.appointmentDate"
                              mode="dateTime"
                              is24hr disabled
                            >
                              <template v-slot="{ inputValue, inputEvents }">
                                <div class="flex justify-center items-center">
                                  <v-text-field
                                    :value="inputValue"
                                    label="Fecha Cita"
                                    v-on="inputEvents"
                                    disabled
                                  >
                                    <v-icon
                                      slot="append"
                                      :color="valid ? 'success' : ''"
                                    >
                                      {{ valid ? " mdi-check" : "" }}
                                    </v-icon>
                                  </v-text-field>
                                </div>
                              </template>
                            </vc-date-picker>
                          </validation-provider> -->
                        </v-col>
                        <v-col cols="6" md="6" sm="12">
                          <validation-provider
                            v-slot="{ errors }"
                            name="Especialidad"
                            rules="required"
                          >
                            <v-autocomplete
                              prepend-icon="mdi mdi-cube-unfolded"
                              v-model="objAltaPaciente.especialityAppointment"
                              label="Especialidad"
                              no-data-text="Sin especialidades por mostrar"
                              :items="specialityList"
                              item-text="name"
                              item-value="idSpeciality"
                              :error-messages="errors"
                              required
                              return-object
                              @change="
                                checkbutton();
                                checkSpecialityWithModal();
                              "
                            ></v-autocomplete>
                          </validation-provider>
                        </v-col>
                        <template
                          v-if="
                            objAltaPaciente.especialityAppointment
                              .idSpeciality == 3 ||
                            objAltaPaciente.especialityAppointment
                              .idSpeciality == 2
                          "
                        >
                          <v-col cols="6" md="6" sm="12">
                            <validation-provider
                              v-slot="{ errors }"
                              name="Modalidad"
                              rules="required"
                            >
                              <v-autocomplete
                                prepend-icon="mdi mdi-developer-board"
                                v-model="objAltaPaciente.modalityAppointment"
                                label="Modalidad"
                                no-data-text="Sin modalidad por mostrar"
                                :items="modalityList"
                                item-text="name"
                                item-value="idModality"
                                :error-messages="errors"
                                required
                                @change="
                                  unfill = true;
                                  fillStudyProfile();
                                "
                              ></v-autocomplete>
                            </validation-provider>
                          </v-col>
                          <v-col cols="6" md="6" sm="12">
                            <validation-provider
                              v-slot="{ errors }"
                              name="Perfil de estudio"
                              rules="required"
                            >
                              <v-autocomplete
                                prepend-icon="mdi mdi-file-alert-outline"
                                v-model="
                                  objAltaPaciente.studyProfileAppointment
                                "
                                label="Perfil de estudio"
                                no-data-text="Sin perfil de estudio por mostrar"
                                :items="labStudyProfileList"
                                item-text="name"
                                item-value="idStudyModality"
                                :error-messages="errors"
                                required
                                return-object
                                @change="unfill = false"
                              >
                              </v-autocomplete>
                            </validation-provider>
                          </v-col>
                        </template>
                        <template>
                          <v-row
                            align="center"
                            justify="space-around"
                            class="d-flex flex-row-reverse mt-5"
                          >
                            <v-col>
                              <v-btn
                                color="primary"
                                @click="addAppointment()"
                                :disabled="unfill || invalid"
                                >Agregar cita
                                <v-icon right>mdi-plus</v-icon>
                              </v-btn>
                            </v-col>
                            <v-spacer></v-spacer>
                          </v-row>
                        </template>
                      </v-row>
                    </v-form>

                    <template v-if="appointmentsList.length > 0">
                      <v-row>
                        <v-col cols="12" md="12" sm="12">
                          <AppointmentsTablexUser
                            :appointmentsList="appointmentsList"
                            :deleteAppointment="deleteAppointment"
                            :objAltaPaciente="objAltaPaciente"
                          />
                        </v-col>
                      </v-row>
                    </template>
                    <v-row
                      align="center"
                      justify="space-around"
                      class="d-flex flex-row-reverse mt-5"
                    >
                      <v-col class="text-center">
                        <v-btn
  color="primary"
  :disabled="unsave || invalid"
  @click="onSaveClick"
>
  Guardar <v-icon right>mdi-content-save</v-icon>
</v-btn>
                      </v-col>
                      <v-col class="text-center">
                        <v-btn plain @click="cleanModal(e1 - 1)" color="error">
                          Cancelar <v-icon right>mdi-close</v-icon>
                        </v-btn>
                      </v-col>
                      <v-col class="text-center">
                        <v-btn color="secondary" text @click="e1 = 4">
                          <v-icon left>mdi-chevron-left</v-icon> Regresar
                        </v-btn>
                      </v-col>
                    </v-row>
                  </validation-observer>
                </v-container>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card-text>
      </v-card>
      <template v-if="flagModal == true && flagSave == true">
        <AppointmentSometryModal
          @changeSometometry="changeSometometry"
          :addDate="saveFilesToPatient"
          :dialogAppointment="dialogAppointment"
          @dialogClose="dialogClose"
        />
      </template>
      <!--Información de usuario con CURP repetido -->
      <v-dialog v-model="modelInfoPatient" persistent max-width="1000">
        <v-card>
          <v-card-title class="text-h6 text-center error--text">
            Se encontró {{ patientInfoList.length }} usuario(s) con la misma
            CURP ingresada
          </v-card-title>
          <validation-observer ref="observer" v-slot="{ invalid }">
            <v-card-text>
              <v-expansion-panels v-model="panelPatient" class="mb-10">
                <v-expansion-panel
                  v-for="(patientInfo, index) in patientInfoList"
                  :key="index"
                >
                  <v-expansion-panel-header>
                    <span>
                      <v-icon left color="grey">mdi-account-search </v-icon
                      >Paciente {{ index + 1 }}
                    </span>
                    <template v-slot:actions>
                      <v-icon color="primary"> $expand </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-container>
                      <v-row>
                        <v-col>
                          <h3 class="font-weight-black">
                            Información personal
                          </h3>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-text-field
                            :value="patientInfo.curp"
                            label="CURP"
                            disabled
                          ></v-text-field>
                        </v-col>
                        <v-col>
                          <v-text-field
                            :value="patientInfo.fullName"
                            label="Nombre"
                            disabled
                          ></v-text-field>
                        </v-col>
                        <v-col>
                          <v-text-field
                            :value="patientInfo.sexText"
                            label="Sexo"
                            disabled
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-text-field
                            :value="patientInfo.birthDate"
                            label="Fecha de nacimiento"
                            disabled
                          >
                          </v-text-field>
                        </v-col>
                        <v-col>
                          <v-text-field
                            :value="patientInfo.birthFederalEntity"
                            label="Entidad federativa de nacimiento"
                            disabled
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <h3 class="font-weight-black">
                            Información de contacto
                          </h3>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-text-field
                            rows="1"
                            :value="patientInfo.address"
                            label="Dirección"
                            id="cancellation"
                            disabled
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-text-field
                            :value="patientInfo.phone"
                            label="Número telefónico móvil"
                            disabled
                            :min="10"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col>
                          <v-text-field
                            :value="patientInfo.homePhone"
                            label="Número telefónico fijo"
                            disabled
                            :min="10"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                    <v-card-actions class="text-center">
                      <v-col>
                        <v-btn
                          :disabled="sending || invalid"
                          color="secondary"
                          @click="createAppointment(patientInfo)"
                        >
                          Agendar cita <v-icon right>mdi-calendar</v-icon>
                        </v-btn>
                      </v-col>
                    </v-card-actions>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card-text>
            <!-- <v-card-actions class="text-center">
              <v-col>
                <v-btn color="error" plain @click="cleanModal(e1 - 1)">
                  Regresar <v-icon right>mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-card-actions> -->
            <v-card-actions class="text-center">
              <v-col>
                <v-btn color="primary" plain @click="modelInfoPatient = false">
                  Continuar <v-icon right>mdi-arrow-right</v-icon>
                </v-btn>
              </v-col>
            </v-card-actions>
          </validation-observer>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import CameraSuim from "@/components/CameraSuim.vue";
import { jsPDF } from "jspdf";
import { base64StringToBlob } from "blob-util";
import AppointmentsTablexUser from "@/components/appointments/AppointmentsTablexUser.vue";
import AppointmentSometryModal from "@/components/appointments/AppointmentSometryModal.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";

import {
  PatientRequest,
  EnumRequest,
  FederalEntityRequest,
  HealthInsuranceRequest,
  MedicalPracticeRequest,
  SepomexRequest,
  EvaluationRequest,
  PatientFileRequest,
  ModaltyRequest,
  SpecialityRequest,
  StudyModalityRequest,
  ReportPDFRequest,
} from "@/core/request";
import Sidebar from "../components/Sidebar.vue";
import Loader from "../components/Loader.vue";
import moment from "moment";
import Encabezado from "@/app/components/base/header/Header.vue";
import { mapActions } from "vuex";
import AutoLogout from "../components/AutoLogout.vue";

export default {
  components: {
    Sidebar,
    ValidationProvider,
    ValidationObserver,
    Loader,
    Encabezado,
    AutoLogout,
    CameraSuim,
    AppointmentsTablexUser,
    AppointmentSometryModal,
  },
  name: "RegistrarPaciente",
  data: (vm) => ({
    show: false,
    action: 1,
    imagePatient: null,
    panel: 0,
    flag: true,
    hint: true,
    hintNoaplica: false,
    sending: false,
    validAdress: false,
    dialogAsk: false,
    loader: false,
    isLoading: false,
    validS1: true,
    validS2: true,
    validS3: true,
    stepForm: [],
    nameRules: [(v) => !!v || "Campo requerido"],
    encabezado: { icono: "mdi-account", texto: "Registrar paciente" },
    e1: 1,
    date2: null,
    date3: null,
    modal: false,
    menu: false,
    menu2: false,
    menu3: false,
    activePicker: null,
    activePicker1: null,
    genero: [
      { text: "Femenino", value: "M" },
      { text: "Masculino", value: "H" },
      { text: "No binario", value: "X" },
    ],
    estadoCivil: [],
    birthFederalEntities: [],
    federalEntities: [],
    municipalities: [],
    colonies: [],
    nationality: [
      { text: "Mexicana", value: "Mexicana" },
      { text: "Otra", value: "Otro" },
    ],
    languages: [
    { text: "Sí", value: 1 },
    { text: "No", value: 0 },
  ],
    date: null,
    dateFormatted: null,
    invalidDate: true,
    dateFormatted1: null,
    invalidDate1: false,
    menu1: false,
    dataDialog: {},
    objAltaPaciente: {
      name: "",
      firstLastname: "",
      secondLastname: "",
      idHealthInsurance: null,
      curp: "",
      medicalAggregated: "",
      gender: "",
      birthFederalEntity: "",
      appointmentDate: new Date(),
      especialityAppointment: {
        idSpeciality: 0,
      },
      indigenousLanguage: null,
    },
    referringPhysician: {
      academicTitle: "",
      name: "",
      firstLastname: "",
      secondLastname: "",
    },
    dataDialog: {},
    listHealthInsurance: [],
    idPatient: "",
    files: undefined,
    mapping: [],
    filesToSave: [],
    //Antecedentes
    antecedents: [],
    //Scanner
    scannedImages: [],
    scannedPDF: [],
    switchDiv: false,
    switchDiv2: false,
    imageAr: [],
    pdfAr: [],
    checkbox: true,
    tamano: 0,
    encendido: 0,
    cambio: 0,
    model: 0,
    xk: 0,
    index: 0,
    pattern: null,
    dialogViewer: false,
    dialog: false,
    imagenesVisuali: [],
    file: {},
    imagenes: [],
    arregloPDF: [],
    a: 0,
    b: 0,
    pdbBase: null,
    patientInfo: {},
    modelInfoPatient: false,
    panelPatient: 0,
    patientInfoList: {},
    otherNationality: "",
    noPostal: false,
    noColony: false,
    otherColony: "",

    /**validaciones */
    genVal: false,
    entityVal: false,
    birthDateVal: false,
    genericCurp: "XXXX999999XXXXXX99",

    /*Registro citas */
    sometriaChoose: true,
    specialityList: [],
    modalityListRequest: [],
    studyProfileList: [],
    minDateTime: null,
    modalityList: [],
    labModalityList: [],
    imgModalityList: [],
    labStudyProfileList: [],
    imgStudyProfileList: [],
    appointmentsList: [],
    unfill: true,
    unsave: true,
    dialogAppointment: false,
    flagModal: false,
    flagSave: false,
    appointmentData: {},
    showVotingLicense: false,
    joblist: [],
    referringPhysicianSwitch: false,
  }),

  created() {
    this.setVotingLicense();
    this.listAntecents();
    this.listAppointment();
    this.validBrowserTab();
    this.listAllEntities();
    this.listJobs();
    this.listMaritalStatus();
    this.listAllHealthInsurances();
    this.specialCharacter();
    this.minDateTime = this.$utilFront.getCurrentDateTime();
    this.objAltaPaciente.appointmentDate = new Date();
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },

  watch: {
    imagePatient(val) {},
    // date(val) {
    //   this.dateFormatted = this.formatDate(this.date);
    //   let result = moment(this.dateFormatted, "DD/MM/YYYY", true).isValid();
    //   let today = moment(new Date()).format("YYYY-MM-DD");
    //   if (result) {
    //     if (this.date < today) {
    //       this.invalidDate = false;
    //       document.getElementById("fechaNac").style = "none";
    //     } else {
    //       this.invalidDate = true;
    //       this.$utilFront.notifications(
    //         "La fecha no puede ser mayor a la fecha actual",
    //         "ERROR"
    //       );
    //       document.getElementById("fechaNac").style.color = "red";
    //     }
    //   } else {
    //     this.invalidDate = true;
    //     this.$utilFront.notifications("Formato de fecha incorrecto", "ERROR");
    //     document.getElementById("fechaNac").style.color = "red";
    //   }
    // },
    date3(val) {
      this.dateFormatted1 = this.formatDate(this.date3);
      let result = moment(this.dateFormatted1, "DD/MM/YYYY", true).isValid();
      let today = moment(new Date()).format("YYYY-MM-DD");
      if (result) {
        if (this.date3 < today) {
          this.invalidDate1 = false;
          document.getElementById("fechaNac1").style = "none";
        } else {
          this.invalidDate1 = true;
          this.$utilFront.notifications(
            "La fecha no puede ser mayor a la fecha actual",
            "ERROR"
          );
          document.getElementById("fechaNac1").style.color = "red";
        }
      } else {
        this.invalidDate1 = true;
        this.$utilFront.notifications("Formato de fecha incorrecto", "ERROR");
        document.getElementById("fechaNac1").style.color = "red";
      }
    },
    appointmentsList: function () {
      if (this.appointmentsList.length > 0) {
        this.unsave = false;
      } else {
        this.unsave = true;
      }
    },
  },

  mounted() {},
  methods: {
    listJobs() {
      PatientRequest.listJobs().then((res) => {
        let { data } = res;
        this.joblist = data;
      });
    },
    setVotingLicense() {
      this.showVotingLicense = false;
      let params = {
        idBranchOffice: this.$utilFront.getIdBranchOffice(),
      };
      PatientRequest.getConfigReception(params).then((res) => {
        let { data, code, status } = res.data;
        if (code === 200 && status === "OK") {
          this.showVotingLicense = data.displayVotingLicense;
        }
      });
    },
    /*** Appointment List & fill modality and study profile ***/
    /*** @MaudePallares **/
    changeSometometry(e) {
      this.sometriaChoose = e;
    },
    dialogClose(e) {
      this.dialogAppointment = e;
    },
    checkSpecialityWithModal() {
      if (
        this.objAltaPaciente.especialityAppointment.idSpeciality == 2 ||
        this.objAltaPaciente.especialityAppointment.idSpeciality == 3
      ) {
        this.fillModality();
      } else {
        return;
      }
    },
    listAppointment() {
  ModaltyRequest.allModality().then((res) => {
    let modality = res.data.data;
    this.modalityListRequest = modality.filter(
      (item) => item.name !== 'PAPANICOLAOU' && item.name !== 'COLPOSCOPIA'
    );
  });

  SpecialityRequest.allSpeciality().then((res) => {
    let specialties = res.data.data;
    this.specialityList = specialties.filter(
      (item) => item.name !== 'TELEMEDICINA' && item.name !== 'COLPOSCOPIA'
    );
  });

  StudyModalityRequest.allStudyModality().then((res) => {
    let studyprofile = res.data.data;
    this.studyProfileList = studyprofile.filter(
      (item) => item.name !== 'COLPOSCOPIA' && item.modality.name !== 'COLPOSCOPIA'
    );
  });
},
    fillModality() {
      let labModality = [];
      let imgModality = [];
      if (this.objAltaPaciente.especialityAppointment.idSpeciality == 3) {
        this.modalityList = [];
        for (let h in this.modalityListRequest) {
          if (
            this.modalityListRequest[h].speciality.idSpeciality ==
            this.objAltaPaciente.especialityAppointment.idSpeciality
          ) {
            labModality = this.modalityListRequest[h];
            this.labModalityList.push(labModality);
          }
          this.modalityList = this.labModalityList;
        }
      } else if (
        this.objAltaPaciente.especialityAppointment.idSpeciality == 2
      ) {
        this.modalityList = [];
        for (let h in this.modalityListRequest) {
          if (
            this.modalityListRequest[h].speciality.idSpeciality ==
            this.objAltaPaciente.especialityAppointment.idSpeciality
          ) {
            imgModality = this.modalityListRequest[h];
            this.imgModalityList.push(imgModality);
          }
        }
        this.modalityList = this.imgModalityList;
      }
      this.fillStudyProfile();
    },
    fillStudyProfile() {
      let labStudyProfile = [];
      this.labStudyProfileList = [];
      for (let h in this.studyProfileList) {
        if (
          this.studyProfileList[h].modality.idModality ==
          this.objAltaPaciente.modalityAppointment
        ) {
          labStudyProfile = this.studyProfileList[h];
          this.labStudyProfileList.push(labStudyProfile);
        }
      }
    },
    /***************************************************************************************** */
    /*** fill table with appointments***/
    /*** @MaudePallares ***/
    checkbutton() {
      if (
        this.objAltaPaciente.especialityAppointment.idSpeciality == 2 ||
        this.objAltaPaciente.especialityAppointment.idSpeciality == 3
      ) {
        this.unfill = true;
      } else {
        this.unfill = false;
      }
    },
    addAppointment() {
      if (this.appointmentsList.length > 0) {
        this.flagModal = true;
      } else {
        this.flagModal = false;
      }
      if (
        this.objAltaPaciente.especialityAppointment.idSpeciality == 2 ||
        this.objAltaPaciente.especialityAppointment.idSpeciality == 3
      ) {
        let appointment = {
          date: new Date(),
          speciality: {
            idSpeciality:
              this.objAltaPaciente.especialityAppointment.idSpeciality,
            name: this.objAltaPaciente.especialityAppointment.name,
          },
          modality: {
            idModality: this.objAltaPaciente.modalityAppointment,
            name: this.objAltaPaciente.studyProfileAppointment.modality.name,
          },
          studyProfile: {
            idStudyProfile:
              this.objAltaPaciente.studyProfileAppointment.idStudyModality,
            name: this.objAltaPaciente.studyProfileAppointment.name,
          },
        };
        this.appointmentData = appointment;
        // this.appointmentsList.push(this.appointmentData);
        //   this.clearAppointments();
        if (this.appointmentsList.length == 0) {
          this.appointmentsList.push(this.appointmentData);
          this.clearAppointments();
        } else if (this.appointmentsList.length > 0) {
          this.validateDoubleAppointment();
          this.clearAppointments();
        }
      } else {
        let appointment = {
          date: new Date(),
          speciality: {
            idSpeciality:
              this.objAltaPaciente.especialityAppointment.idSpeciality,
            name: this.objAltaPaciente.especialityAppointment.name,
          },
          modality: {
            idModality: "",
            name: "----",
          },
          studyProfile: {
            idStudyProfile: "",
            name: "----",
          },
        };
        this.appointmentData = appointment;
        // this.appointmentsList.push(this.appointmentData);
        //   this.clearAppointments();
        if (this.appointmentsList.length == 0) {
          this.appointmentsList.push(this.appointmentData);
          this.clearAppointments();
        } else if (this.appointmentsList.length > 0) {
          this.validateAppointmentWithoutModality();
          this.clearAppointments();
        }
      }
    },
    validateDoubleAppointment() {
      let flag = false;
      for (let p = 0; p < this.appointmentsList.length; p++) {
        if (
          this.appointmentsList[p].studyProfile.idStudyProfile ==
          this.appointmentData.studyProfile.idStudyProfile
        ) {
          flag = true;
        }
      }
      if (flag) {
        this.$utilFront.notifications(
          "Cita ya registrada, no se puede registrar dos veces",
          "ERROR"
        );
      } else {
        this.appointmentsList.push(this.appointmentData);
      }
    },
    validateAppointmentWithoutModality() {
      let flag = false;
      for (let p = 0; p < this.appointmentsList.length; p++) {
        if (
          this.appointmentsList[p].speciality.idSpeciality ==
          this.appointmentData.speciality.idSpeciality
        ) {
          flag = true;
        }
      }
      if (flag) {
        this.$utilFront.notifications(
          "Cita ya registrada, no se puede registrar dos veces",
          "ERROR"
        );
      } else {
        this.appointmentsList.push(this.appointmentData);
      }
    },
    clearAppointments() {
      this.unfill = true;
      this.objAltaPaciente.especialityAppointment = {};
      this.objAltaPaciente.modalityAppointment = "";
      this.objAltaPaciente.studyProfileAppointment = {};
      this.appointmentData = {};
    },
    deleteAppointment(index) {
      // console.log(index);
      this.flagSave = false;
      this.appointmentsList.splice(index, 1);
    },
    /***************************************************************************************** */
    /*** Validation funtions ***/
    /*** @MaudePallares ***/

    initCurpValidation() {
      this.gendervalidation();
      this.entityvalidation();
      this.birthdatevalidation();
    },
    gendervalidation() {
      let validate = true;
      let curpgender = this.objAltaPaciente.curp;
      if (this.genericCurp == this.objAltaPaciente.curp) {
        validate = false;
        this.genVal = false;
        this.objAltaPaciente.gender = null;
      }
      if (validate) {
        switch (curpgender.charAt(10)) {
          case "H":
            this.objAltaPaciente.gender = "H";
            this.genVal = true;
            break;
          case "M":
            this.objAltaPaciente.gender = "M";
            this.genVal = true;
            break;
          case "X":
            this.objAltaPaciente.gender = "X";
            this.genVal = true;
            break;
        }
      }
    },
    entityvalidation() {
      let validate = true;
      let entityName = "";
      let entityCurp =
        this.objAltaPaciente.curp.charAt(11) +
        this.objAltaPaciente.curp.charAt(12);
      if (this.genericCurp == this.objAltaPaciente.curp) {
        validate = false;
        this.entityVal = false;
        this.objAltaPaciente.birthFederalEntity = null;
      }
      if (validate) {
        for (let i in this.birthFederalEntities) {
          if (this.birthFederalEntities[i].entitykey == entityCurp) {
            entityName = this.birthFederalEntities[i].text;
          }
        }
        this.objAltaPaciente.birthFederalEntity = entityName;
        this.entityVal = true;
      }
    },
    birthdatevalidation() {
      let validate = true;
      if (this.genericCurp == this.objAltaPaciente.curp) {
        validate = false;
      }
      if (validate) {
        let currentyear = moment().local().format("YY");
        let birthyear =
          this.objAltaPaciente.curp.charAt(4) +
          this.objAltaPaciente.curp.charAt(5);
        let birthYearCurp =
          birthyear > currentyear ? "19" + birthyear : "20" + birthyear;
        let birthDateCurp =
          birthYearCurp +
          "-" +
          this.objAltaPaciente.curp.charAt(6) +
          this.objAltaPaciente.curp.charAt(7) +
          "-" +
          this.objAltaPaciente.curp.charAt(8) +
          this.objAltaPaciente.curp.charAt(9);
        // let formatbirthDateCurp = moment(birthDateCurp, "YYYY-MM-DD").format(
        //   "yyyy-MM-DD"
        // );
        this.date = birthDateCurp;
      }
    },
    /******************************************************************************************/
    viawerPDF(src) {
      const images = src;

      let index = 0;
      let htmlCustom = "";

      const rem = /png/i;
      let url = images.replace(rem, "jpeg");
      var doc = new jsPDF();
      var imgData = url;
      var width = doc.internal.pageSize.getWidth();
      var height = doc.internal.pageSize.getHeight();

      doc.setFontSize(40);
      doc.text(35, 25, " ");
      doc.addImage(imgData, "JPEG", 0, 0, width, height);
      this.file = this.pdbBase = doc;
      this.dialogViewer = true;
      doc.output("datauristring");
      this.pdbBase = doc.output("datauristring");
    },
    viawerIMG(src) {
      this.imagenesVisuali = [];
      this.imagenesVisuali.push(src);
    },
    ViewAllPDF() {
      let index = 1;

      var doc = new jsPDF();
      var width = doc.internal.pageSize.getWidth();
      var height = doc.internal.pageSize.getHeight();
      doc.setFontSize(40);
      doc.text(35, 25, "");

      this.pdfAr.forEach((img) => {
        if (index > 0);
        const rem = /png/i;
        let url = img.replace(rem, "jpeg");
        var imgData = url;
        doc.addImage(imgData, "JPEG", 0, 0, width, height);
        doc.addPage();
        this.file = this.pdbBase = doc;
      });
      doc.deletePage(doc.internal.getNumberOfPages());
      this.pdbBase = doc.output("datauristring");
      doc.output("datauristring");
      doc.output("save", "filename.pdf");
    },
    deleteIMG(src) {
      const existe = (element) => element === src;
      this.imageAr.splice(this.imageAr.findIndex(existe), 1);
    },
    deletePDF(src) {
      const existe = (element) => element === src;
      this.pdfAr.splice(existe, 1);
    },
    ScannerIMG() {
      const rem = /png/i;
      this.switchDiv = true;
      const iframe = document.querySelectorAll("iframe");
      const images =
        iframe[0].contentWindow.document.body.querySelectorAll("img");
      let index = 0;
      let htmlCustom = "";
      images.forEach((img) => {
        let url = img.src.replace(rem, "jpeg");
        var imagens = new Image();
        imagens.src = url;
        this.imagenes.push(imagens);
        if (index > 0) this.imageAr.push(imagens.src);
        const div = iframe[0].contentWindow.document.body.querySelector(
          "div[id=thumbnail_chain]"
        );
        this.tamano = this.imageAr.length;
        div.innerHTML = "";
        htmlCustom += `<v-col align="center">  <img src="${img.src}"  style="width: 150px; height: 150px;  margin-right: 5px;"class="thumbnail img-responsive"> </v-col>`;
        index++;
      });
      return true;
    },
    ScannerPDF() {
      this.switchDiv = true;
      const iframe = document.querySelectorAll("iframe");
      const images =
        iframe[0].contentWindow.document.body.querySelectorAll("img");
      let index = 0;
      let htmlCustom = "";

      images.forEach((img) => {
        if (index > 0) this.pdfAr.push(img.src);
        const iframe = document.querySelectorAll("iframe");
        const div = iframe[0].contentWindow.document.body.querySelector(
          "div[id=thumbnail_chain]"
        );
        div.innerHTML = "";
        htmlCustom += `<v-col align="center">  <img src="${img.src}"  style="width: 150px; height: 150px;  margin-right: 5px;"class="thumbnail img-responsive"> </v-col>`;
        index++;
      });
    },

    ...mapActions(["validTab", "unauthorized"]),
    async getImage() {
      return await this.$refs.cameraSUIM.getImage();
    },
    async getImage64() {
      return await this.$refs.cameraSUIM.getImage64();
    },
    validBrowserTab() {
      this.validTab();
    },
    deleteFile(fileName) {
      let i = this.files.findIndex((index) => index.name === fileName);
      if (i > -1) {
        this.files.splice(i, 1);
      }
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    showInput() {
      if (this.objAltaPaciente.idHealthInsurance.text) {
        if (
          this.objAltaPaciente.idHealthInsurance.text.toLowerCase() ===
          "IMSS".toLowerCase()
        ) {
          this.flag = false;
          this.hint = false;
          this.hintNoaplica = false;
        } else if (
          this.objAltaPaciente.idHealthInsurance.text.toLowerCase() ===
          "NO APLICA".toLowerCase()
        ) {
          this.flag = false;
          this.hint = false;
          this.hintNoaplica = true;
        } else if (
          this.objAltaPaciente.idHealthInsurance.text.toLowerCase() ===
          "OTRO".toLowerCase()
        ) {
          this.flag = true;
          this.hint = false;
          this.hintNoaplica = false;
        } else if (
          this.objAltaPaciente.idHealthInsurance.text.toLowerCase() !==
          "IMSS".toLowerCase()
        ) {
          this.flag = true;
          this.hint = true;
          this.hintNoaplica = false;
        }
      }
    },
    ask() {
      this.dialogAsk = true;
    },
    generatedDate() {
      this.dialogAsk = false;
      this.sending = true;

      let clinicalEvent = {
        eventType: 1,
        patient: { idPatient: this.idPatient },
      };

      let appointment = {
        reason: "",
        type: 1,
        startTime: new Date(),
        serviceType: 1,
        speciality: 1,
        clinicalEvent: clinicalEvent,
        humanResourceOrigin: {
          idHumanResource: this.$utilFront.getIdHumanResource(),
        },
      };

      let data = {
        idBranchOfficeOrigin: this.$utilFront.getIdBranchOffice(),
        appointment: appointment,
      };

      MedicalPracticeRequest.addMedicalPractice(data)
        .then((res) => {
          let { code, data, status } = res.data;
          if (code === 200 && status === "OK") {
            this.$utilFront.notifications("Cita registrada", "SUCCESS");
          } else {
            this.$utilFront.notifications(
              "Cita no registrada, inténte mantualmente",
              "ERROR"
            );
          }
          this.$router.go(-1);
        })
        .finally(() => {
          this.sending = false;
        });
    },
    upperCase(e) {
      if (this.objAltaPaciente.curp) {
        this.objAltaPaciente.curp = e.toUpperCase();
      }
    },
    firstLetterToUpperCase() {
      if (this.objAltaPaciente.name != null) {
        let name = this.objAltaPaciente.name;
        let nameUpper = name.charAt(0).toUpperCase() + name.slice(1);
        this.objAltaPaciente.name = nameUpper;
      }
      if (this.objAltaPaciente.firstLastname != null) {
        let lastname = this.objAltaPaciente.firstLastname;
        let lastnameUpper =
          lastname.charAt(0).toUpperCase() + lastname.slice(1);
        this.objAltaPaciente.firstLastname = lastnameUpper;
      }
      if (this.objAltaPaciente.secondLastname != null) {
        let secondlastname = this.objAltaPaciente.secondLastname;
        let secondlastnameUpper =
          secondlastname.charAt(0).toUpperCase() + secondlastname.slice(1);
        this.objAltaPaciente.secondLastname = secondlastnameUpper;
      }
    },
    save(date) {
      this.$refs.menu.save(date);
    },
    saveNac(date2) {
      this.$refs.menu1.save(date2);
    },
    saveDef(date3) {
      this.$refs.menu3.save(date3);
    },
    validStep(n) {
      switch (n) {
        case 1:
          this.$refs.formIM.validate();
          break;
        case 2:
          this.$refs.formIP.validate();
          break;
        case 3:
          this.$refs.formIC.validate();
          break;
      }
    },
    cleanModal(n) {
      this.dialog = !this.dialog;

      this.$refs.formIM.reset();
      this.$refs.formIM.resetValidation();

      this.$refs.formIP.reset();
      this.$refs.formIP.resetValidation();

      this.$refs.formIC.reset();
      this.$refs.formIC.resetValidation();

      // this.$refs.formID.reset();
      // this.$refs.formID.resetValidation();

      this.$refs.formAD.reset();
      this.$refs.formAD.resetValidation();

      this.e1 = 1;
      this.$router.go(-1);
    },
    resetInputs() {
      if (
        this.objAltaPaciente.imssNumber &&
        this.objAltaPaciente.medicalAggregated
      ) {
        this.objAltaPaciente.imssNumber = "";
        this.objAltaPaciente.medicalAggregated = "";
      } else if (this.objAltaPaciente.membershipNumber) {
        this.objAltaPaciente.membershipNumber = "";
      } else if (
        this.objAltaPaciente.nameOther &&
        this.objAltaPaciente.description &&
        this.objAltaPaciente.membershipNumber
      ) {
        this.objAltaPaciente.nameOther = "";
        this.objAltaPaciente.description = "";
        this.objAltaPaciente.membershipNumber = "";
      }
    },
    specialCharacter() {
      let from = "ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç",
        to = "AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc";

      for (let i = 0, j = from.length; i < j; i++) {
        this.mapping[from.charAt(i)] = to.charAt(i);
      }
    },
    async addPatient() {
      let clearAppointments = this.appointmentsList.map(function (
        appointmentitem
      ) {
        let clearAppointments = {
          dateAppointment: appointmentitem.date,
          speciality: appointmentitem.speciality.idSpeciality,
          modality: appointmentitem.modality.idModality,
          studyProfile: appointmentitem.studyProfile.idStudyProfile,
        };
        return clearAppointments;
      });

      this.sending = true;
      let idHumanResource = this.$utilFront.getIdHumanResource();
      let userData = this.objAltaPaciente;
      let idee = "";
      let enti;
      let nan;
      let medicalAggregated = "";
      if (userData.medicalAggregated === "") {
        medicalAggregated = "00000000";
      } else {
        medicalAggregated = userData.medicalAggregated;
      }
      if (this.$utilFront.isEmpty(userData.imssNumber)) {
        idee = "";
      } else {
        idee = userData.imssNumber + medicalAggregated;
      }

      if (this.noPostal || this.noColony) {
        userData.colonyKey = this.otherColony;
      }
      this.imagePatient = await this.getImage64();

      if (userData.nationality === "Otro") {
        enti = "Ninguno";
        nan = this.otherNationality;
      } else {
        enti = userData.birthFederalEntity;
        nan = userData.nationality;
      }
      let postRegisterPatient = {
        imagePatient: this.imagePatient,
        idee: idee,
        imssNumber: userData.imssNumber,
        patientNumber: "",
        medicalAggregated: medicalAggregated,
        rfc: userData?.rfc,
        educationName: userData.educationName?.name,
        sendInformation :userData.sendInformation,
        membershipNumber: userData.membershipNumber,
        healthInsurance: {
          idHealthInsurance: userData.idHealthInsurance.value,
          name: userData.nameOther,
          description: userData.description,
        },

        person: {
          name: userData.name,
          firstLastname: userData.firstLastname,
          secondLastname: userData.secondLastname,
          curp: userData.curp,
          gender: userData.gender,
          birthDate: moment(this.date).startOf("day"),
          birthDateText: this.date,
          birthFederalEntity: enti,
          maritalStatus: userData.maritalStatus,
          indigenousLanguage: this.objAltaPaciente.indigenousLanguage,
          contactInformation: {
            email: userData.email,
            phone: userData.phone,
            homePhone: userData.homePhone,
          },
          branchOffice: {
            idBranchOffice: this.$utilFront.getIdBranchOffice(),
          },
          address: {
            interiorNumber: userData.interiorNumber,
            outdoorNumber: userData.outdoorNumber,
            postalCode: userData.postalCode,
            street: userData.street,
            federalEntityKey: userData.federalEntityKey,
            municipalityKey: userData.municipalityKey,
            colonyKey: userData.colonyKey,
          },
          nationality: nan,
        },
        antecedents: this.antecedents,
        scannedImages: [],
        scannedPDF: [],
        withSomatometry: this.sometriaChoose,
        idHumanResource: idHumanResource,
        appointmentList: clearAppointments,
        votingLicense: {
          votingLicenseKey: userData.votingLicenseKey,
          section: userData.section,
        },
        occupation: userData.idOccupation,
        referringPhysician: this.referringPhysicianSwitch
          ? this.referringPhysician
          : null,
      };
      let appointmentsPDF = {
        appointmentList: clearAppointments,
        withSomatometry: this.sometriaChoose,
      };
      if (
        this.$refs.formIM.validate() &&
        this.$refs.formIP.validate() &&
        this.$refs.formIC.validate()
      ) {
        this.loader = true;
        this.sending = true;
        PatientRequest.addPatient(postRegisterPatient)
          .then((res) => {
            if (res.data) {
              if (res.data.response === true) {
                this.idPatient = res.data.data.idPaciente;

                if (
                  this.$utilFront.nonEmptyList(
                    postRegisterPatient?.appointmentList
                  )
                ) {
                  let dateAppointment =
                    postRegisterPatient?.appointmentList[0]?.dateAppointment;
                  let dataReport = {
                    idPatient: this.idPatient,
                    registrationDate: dateAppointment,
                  };
                  ReportPDFRequest.downloadOrderStudyReception(dataReport).then(
                    (response) => {
                      this.$utilFront.openPDF(response.data);
                    }
                  );
                }

                this.$utilFront.notifications(
                  "Paciente registrado & cita registrada",
                  "SUCCESS"
                );

                if (this.$utilFront.isEmptyList(this.filesToSave)) {
                  // this.$utilFront.notifications(res.data.message, "ERROR");
                  // this.afterSave();
                  this.$router.push("/recepcion");
                } else {
                  this.saveFiles();
                  this.$router.push("/recepcion");
                }
              } else {
                // this.$utilFront.notifications(res.data.message, "ERROR");
                this.$router.push("/recepcion");
              }
            }
          })
          .finally(() => {
            this.sending = false;
            this.loader = false;
          });
      }
    },

    afterSave() {
      this.loader = false;
      this.sending = false;
      if (this.$utilFront.nonLite()) {
        this.ask();
      } else {
        this.generatedDate();
      }
    },
    saveFiles() {
      let lastItem = 0;

      for (let i = 0; i < this.filesToSave.length; i++) {
        this.loader = true;
        this.sending = true;

        let paramFile = {
          idPatient: this.idPatient,
          idBranchOffice: this.$utilFront.getIdBranchOffice(),
          addendum: this.filesToSave[i],
        };
        PatientFileRequest.addScannerFiles(paramFile)
          .then((res) => {
            let { data, response, message } = res.data;
            if (!response) {
              /* this.$utilFront.notifications(
                message || "Ocurrió un error al registrar los archivos.",
                "ERROR"
              );*/
            }
          })
          .finally(() => {
            lastItem = lastItem + 1;
            if (this.filesToSave.length == lastItem) {
              //  this.afterSave();
            }
          });
      }
      //  let addendumList: this.filesToSave,
    },
    /// Antecente -> inicio
    listAntecents() {
      this.sending = true;
      this.antecedents = [];
      EvaluationRequest.listAllByType({ type: 1 })
        .then((res) => {
          let { data, response, message } = res.data;
          if (response) {
            this.antecedents = data;
            this.panel = this.antecedents.map((it, i) => {
              return i;
            });
            setTimeout(
              function () {
                this.panel = [0];
              }.bind(this),
              1000
            );
          } else {
            this.antecedents = [];
          }
        })
        .finally(() => {
          this.sending = false;
        });
    },
    // Antecente -> fin

    getBase64(files) {
      try {
        let reader = new FileReader();
        for (let file of files) {
          reader = new FileReader();
          let fileByte = [];
          reader.readAsArrayBuffer(file);
          reader.onload = (evt) => {
            if (evt.target.readyState == FileReader.DONE) {
              let arrayBuffer = evt.target.result;
              let array = new Uint8Array(arrayBuffer);
              for (let byte of array) {
                fileByte.push(byte);
              }
            }
            let c = "";
            for (var i = 0, j = file.name.length; i < j; i++) {
              var l = file.name.charAt(i);
              c = c + (l in this.mapping ? this.mapping[l] : l);
            }
            let te = c.replace(/[^a-zA-Z0-9-_+{}()&$!#%. ]/g, "");
            let f = {
              bytes: fileByte,
              fileName: te,
              type: file.type,
            };
            this.filesToSave.push(f);
          };
          reader.onerror = function (error) {
            this.$utilFront.notifications(
              "Ha ocurrido un error interno",
              "ERROR"
            );
            //console.log("Error: ", error);
          };
        }
        reader.onloadend = (end) => {
          this.addPatient();
        };
      } catch (e) {
      } finally {
      }
    },

    saveFilesToPatient() {
      if (!this.sending) {
        this.sending = true;
        if (this.$utilFront.isEmptyList(this.files)) {
          this.files = [];
        }

        let index = 1;

        for (let i = 0; i < this.pdfAr.length; i++) {
          const element = this.pdfAr[i];

          var doc = new jsPDF();
          var width = doc.internal.pageSize.getWidth();
          var height = doc.internal.pageSize.getHeight();
          doc.setFontSize(40);
          doc.text(35, 25, "");
          const rem = /png/i;
          let url = element.replace(rem, "jpeg");
          var imgData = url;
          doc.addImage(imgData, "JPEG", 0, 0, width, height);
          this.file = this.pdbBase = doc;
          this.pdbBase = doc.output("datauristring");
          this.arregloPDF.push(doc.output("datauristring"));
        }

        if (!this.$utilFront.isEmptyList(this.arregloPDF)) {
          for (let i = 0; i < this.arregloPDF.length; i++) {
            let fileName = "Archivo" + this.b + ".pdf";
            const file = this.$utilFront.stringBase64ToFile(
              this.arregloPDF[i],
              fileName
            );
            this.files.push(file);
            this.b++;
          }
        }
        if (!this.$utilFront.isEmptyList(this.imageAr)) {
          for (let i = 0; i < this.imageAr.length; i++) {
            let fileName = "Imagen" + this.a + ".jpeg";
            const file = this.$utilFront.stringBase64ToFile(
              this.imageAr[i],
              fileName
            );
            this.files.push(file);
            this.a++;
          }
        }

        if (!this.$utilFront.isEmptyList(this.files)) {
          this.getBase64(this.files);
        } else {
          this.addPatient();
        }
      }
    },

    listAllHealthInsurances() {
      HealthInsuranceRequest.listAllHealthInsurance().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.listHealthInsurance = res.data.data.map((insurance) => {
            return {
              text: insurance.name,
              value: insurance.idHealthInsurance,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },

    listAllEntities() {
      FederalEntityRequest.listAllFederalEntity().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.birthFederalEntities = res.data.data.map((birthEntity) => {
            return {
              text: birthEntity.name,
              value: birthEntity.name,
              entitykey: birthEntity.federalEntityKey,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },

    listMaritalStatus() {
      EnumRequest.listAllMaritalStatus().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.estadoCivil = res.data.data.map((status) => {
            return {
              text: status.text,
              value: status.value,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    findAddress() {
      if (this.objAltaPaciente?.postalCode.length == 5) {
        let postalCode = this.objAltaPaciente.postalCode;
        this.sending = true;
        this.validAdress = false;
        this.federalEntities = [];
        SepomexRequest.listAllByPostalCode({ postalCode: `${postalCode}` })
          .then((res) => {
            let { data, response, message } = res.data;

            this.validAdress = response;

            if (response) {
              this.noPostal = false;
              this.federalEntities = data
                .map((it) => {
                  this.objAltaPaciente.federalEntityKey = it.federalEntity;
                  return it.federalEntity;
                })
                .filter(this.onlyUnique);

              this.municipalities = data
                .map((it) => {
                  this.objAltaPaciente.municipalityKey = it.municipality;
                  return it.municipality;
                })
                .filter(this.onlyUnique);

              this.colonies = data
                .map((it) => {
                  this.objAltaPaciente.colonyKey = it.settlement;
                  return it.settlement;
                })
                .filter(this.onlyUnique);
            } else {
              this.noPostal = true;
              this.$utilFront.notifications(
                "Código postal no registrado, capturar manualmente.",
                "WARNING"
              );
            }
          })
          .finally(() => {
            this.colonies.push("Otro");
            this.sending = false;
          });
      }
    },
    onlyUnique(value, index, self) {
      const otherColony = {
        settlement: "Otro",
      };
      return self.indexOf(value) === index;
    },
    //Scanner
    scanAsImage() {
      let settings = {
        output_settings: [{ type: "return-base64", format: "jpg" }],
      };
      scanner.scan(this.displayImagesOnPage, settings);
    },

    scann() {
      document.querySelectorAll("iframe").forEach((item) => {
        const ggg = item.contentWindow.document.body.querySelectorAll("img");

        const im = ggg[1].src;

        if (ggg.length == 0) {
          alert("No Images found, please scan some images first.");
          return false;
        }
        document.getElementsByName("constr").src = im;
      });
    },
    displayImagesOnPage(successful, mesg, response) {
      if (!successful) {
        // On error
        this.$utilFront.notifications("Error en lectura de archivo.", "ERROR");
        return;
      }

      if (
        successful &&
        mesg != null &&
        mesg.toLowerCase().indexOf("user cancel") >= 0
      ) {
        // User cancelled.
        this.$utilFront.notifications("Cancelado.", "WARNING");
        return;
      }

      var scannedImages = scanner.getScannedImages(response, true, false); // returns an array of ScannedImage
      for (
        var i = 0;
        scannedImages instanceof Array && i < scannedImages.length;
        i++
      ) {
        var scannedImage = scannedImages[i];
        this.scannedImages.push({
          file64: scannedImage.src,
          fileName: "Sin titulo (" + (i + 1) + ")",
          format: "jpg",
        });
      }
    },
    scanAsPDF() {
      let settingsFormat = {
        type: "return-base64-thumbnail",
        format: "jpg",
        thumbnail_height: 200,
        image_text_line: "",
      };
      let settings = {
        output_settings: [
          { type: "return-base64", format: "pdf" },
          settingsFormat,
        ],
      };
      scanner.scan(this.displayImagesOnPagePDF, settings);
    },
    displayImagesOnPagePDF(successful, mesg, response) {
      if (!successful) {
        // On error
        this.$utilFront.notifications("Error en lectura de archivo.", "ERROR");
        return;
      }

      if (
        successful &&
        mesg != null &&
        mesg.toLowerCase().indexOf("user cancel") >= 0
      ) {
        // User cancelled.
        this.$utilFront.notifications("Cancelado.", "WARNING");
        return;
      }

      var scannedImages = scanner.getScannedImages(response, true, false); // returns an array of ScannedImage
      for (
        var i = 0;
        scannedImages instanceof Array && i < scannedImages.length;
        i++
      ) {
        var scannedImage = scannedImages[i];
        this.scannedPDF.push({
          file64: scannedImage.src,
          fileName: "Sin titulo (" + (i + 1) + ")",
          format: "pdf",
        });
      }
    },
    validateCurp(e) {
      if (this.objAltaPaciente.curp == this.genericCurp) {
        return;
      } else {
        let data = {
          person: { curp: this.objAltaPaciente.curp },
        };
        PatientRequest.validCurpPatient(data).then((res) => {
          if (res.data.code === 200 && typeof res.data.data == "object") {
            if (res.data.data != null) {
              // this.$utilFront.notifications(
              //   "Ya se ha registrado un paciente con la misma CURP.",
              //   "WARNING"
              // );
              this.patientInfoList = res.data.data.map((d) => {
                d.birthDate =
                  moment(new Date(d.birthDate))
                    .locale("es")
                    .format("DD/MM/YYYY") || "---";
                //d.phone = (res.data.data.phone != null? res.data.data.phone: "ND")
                return d;
              });
              this.modelInfoPatient = true;
              this.panelPatient = 0;
            }
          } else if (res.data.code === 401) {
            this.unauthorized();
          } else {
          }
        });
      }
    },
    createAppointment(patient) {
      this.sending = true;
      this.loader = true;
      this.$router.push({
        name: "CrearCita",
        params: { idPatient: patient.idPatient },
      });
    },
    checkColony() {
      if (this.objAltaPaciente.colonyKey === "Otro") {
        this.noColony = true;
        this.otherColony = "";
      } else {
        this.noColony = false;
        this.otherColony = "";
      }
    },

    onSaveClick() {

    const m    = this.objAltaPaciente;                              
    const esId = m.especialityAppointment?.idSpeciality;

    // Si es laboratorio/imagen
    if ([2,3].includes(esId)) {
      if (!m.modalityAppointment || !m.studyProfileAppointment?.idStudyModality) {
        return this.$utilFront.notifications(
          'Agrega o elimina la cita pendiente.',
          'ERROR'
        );
      }
      const yaLab = this.appointmentsList.some(s =>
        s.speciality.idSpeciality   === esId &&
        s.modality.idModality       === m.modalityAppointment &&
        s.studyProfile.idStudyProfile === m.studyProfileAppointment.idStudyModality
      );
      if (!yaLab) {
        return this.$utilFront.notifications(
          'Agrega o elimina la cita pendiente..',
          'ERROR'
        );
      }
    }

    // Si es una especialidad y está seleccionada pero NO añadida
    else if (esId) {
      const yaPure = this.appointmentsList.some(s =>
        s.speciality.idSpeciality === esId
      );
      if (!yaPure) {
        return this.$utilFront.notifications(
          'Agrega o elimina la cita pendiente.',
          'ERROR'
        );
      }
    }

    // Si no hay ninguna cita en la tabla
    if (this.appointmentsList.length === 0) {
      return this.$utilFront.notifications(
        'Agrega o elimina la cita pendiente.',
        'ERROR'
      );
    }

    // Se abre el modal
    this.e1                = 5
    this.cambio            = 0
    this.dialogAppointment = true;
    this.flagSave         = true;
    this.flagModal        = true;
  }
  },
};
</script>
